import effectsEn from "./effects-en.webp"
import goalEn from "./goal-en.webp"
import goalRu from "./goal-ru.webp"
import goalUk from "./goal-uk.webp"
import guideEn from "./guide-en.webp"
import howToPlayEn from "./howToPlay-en.webp"
import runesEn from "./runes-en.webp"
import runesRu from "./runes-ru.webp"
import runesUk from "./runes-uk.webp"
import screenEn from "./screen-en.webp"
import screenRu from "./screen-ru.webp"
import screenUk from "./screen-uk.webp"
import screenLayoutEn from "./screenLayout-en.webp"
import screenLayoutRu from "./screenLayout-ru.webp"
import screenLayoutUk from "./screenLayout-uk.webp"

type Lang = "en" | "uk" | "ru"

export const tutorialImages = {
  goal: { en: goalEn, uk: goalUk, ru: goalRu },
  screen: { en: screenEn, uk: screenUk, ru: screenRu },
  screenLayout: {
    en: screenLayoutEn,
    uk: screenLayoutUk,
    ru: screenLayoutRu
  },
  howToPlay: { en: howToPlayEn },
  runes: { en: runesEn, uk: runesUk, ru: runesRu },
  effects: { en: effectsEn },
  guide: { en: guideEn }
} as const satisfies Record<string, Partial<Record<Lang, string>>>
